export default __webpack_public_path__ + "static/media/calendar.366e0a2b.png";